"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),function(e){for(var r in e)exports.hasOwnProperty(r)||(exports[r]=e[r])}(require("./linear-gradient"));
//# sourceMappingURL=/@diez/framework-core/lib/index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@diez/framework-core/lib/index.js
// module id = 411
// module chunks = 168707334958949